/**
 * Generate AFG remove link using the pages current URL.
 * @returns {undefined}
 */
const setAfgRemoveLink = function() {
	let url = new URL(window.location.href),
		searchParams = new URLSearchParams();

	url.searchParams.forEach((value, key) => {
		let denyList = [
			'afg[vehicle_type_group]',
			'afg[year]',
			'afg[make]',
			'afg[model]',
			'afg[body]',
			'afg[trim]',
			'afg[audio]',
			'afg[product_model]',
			'page',
			'show_parts_that_fit_first',
			'stay'
		];
		if (denyList.includes(key)) {
			// Do nothing.
		} else {
			searchParams.append(key, value);
		}
	});

	searchParams.set('afg', 'remove');

	$('.remove-vehicle').attr('href', url.pathname + '?' + searchParams.toString());
};

export default setAfgRemoveLink;
